module.exports = __webpack_public_path__ + "static/23-tat7-ce2becaedcedf992d44836ba0d004fea.jpg";